import { Component, EventEmitter, Renderer2, forwardRef, OnChanges, AfterViewInit } from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";
import { TfDropdownService } from "../tf-drop-down.service";
import { DropdownOption } from "../model/DropdownOption";

export const MULTI_SELECT_DROP_DOWN_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TfMultiSelectDropdownComponent),
    multi: true
};

@Component({
    selector: 'tf-multi-select-dropdown',
    templateUrl: './tf-multi-select-dropdown.component.html',
    styleUrls: ['./tf-multi-select-dropdown.component.scss'],
    inputs: ['options', 'size', 'inlineLabel', 'externalLabel', 'scrollHeight', 'optionLabelKey', 'searchPlaceHolder', 'search', 'virtualScroll', 'disable', 'overlayWidth'],
    providers: [MULTI_SELECT_DROP_DOWN_VALUE_ACCESSOR],
    outputs: ['onChange', 'onClick', 'onReset']
})
export class TfMultiSelectDropdownComponent implements OnChanges, AfterViewInit, ControlValueAccessor {

    constructor(
        public renderer: Renderer2,
        private dropdownService: TfDropdownService
    ) {
    }

    options: DropdownOption[] = [];
    size: string = 'medium';
    inlineLabel: string = "Select";
    externalLabel: boolean = false;
    optionLabelKey: string = null;
    optionSelectKey: string = null;
    scrollHeight: number;
    searchPlaceHolder: string = "search";
    search: boolean = false;
    virtualScroll: boolean = false;
    disable: boolean = false;
    overlayWidth: string = "auto";

    onChange: EventEmitter<any> = new EventEmitter();
    onClick: EventEmitter<any> = new EventEmitter();
    onReset: EventEmitter<any> = new EventEmitter();

    valueAsString: string;
    visibleOptions: DropdownOption[];
    multiSelectOptions: DropdownOption[] = [];
    searchInputValue: string;
    isSearchFilter: boolean = false;
    isItemSelected: boolean = false;
    overlayVisible: boolean = false;
    documentClickListener: any;
    selfClick: boolean;
    isArrayOfStrings: boolean = false;
    selectedOptions: DropdownOption[] = [];

    _onTouched: () => void = () => {
    };

    _onChange: (item: unknown) => void = () => {
    };


    ngOnChanges() {
        this.isArrayOfStrings = this.dropdownService.isArrayOfStringType(this.options);
        if (this.options && this.options.length > 0) {
            if (this.isArrayOfStrings) {
                this.optionLabelKey = null;
                this.multiSelectOptions = JSON.parse(JSON.stringify(this.dropdownService.convertStringArrayToArrayOfObjects(this.options, 'label')));
            } else {
                this.multiSelectOptions = JSON.parse(JSON.stringify(this.options));
            }
        } else {
            this.multiSelectOptions = [];
        }
        if (this.selectedOptions && this.selectedOptions.length > 0) {
            this.updateSelected();
        } else {
            this.updateLabel();
        }
    }

    ngAfterViewInit() {
        if (this.overlayVisible) {
            this.show();
        }
    }

    updateLabel = () => {
        if (this.isItemSelected && this.selectedOptions && this.selectedOptions.length > 0) {
            const count: string = (this.selectedOptions.length - 1) > 0 ? (", +" + (this.selectedOptions.length - 1).toString()) : " ";
            this.valueAsString = (this.isArrayOfStrings ? this.selectedOptions[0] : this.optionLabelKey ? this.selectedOptions[0][this.optionLabelKey] : this.selectedOptions[0]['label']) + count;
        } else {
            this.valueAsString = this.inlineLabel;
        }
    };

    onMouseClick = (event) => {
        if (this.overlayVisible) {
            this.hide();
            this._onTouched();
        } else {
            this.ngOnChanges();
            this.show();
        }
        this.onClick.emit({
            originalEvent: event,
            selectedOptions: JSON.parse(JSON.stringify(this.selectedOptions))
        });
        this.selfClick = true;
    };

    onOptionClick = (event, option) => {
        event.option = option;
        const index = this.findIndexInList(this.visibleOptions, event.option);
        const indexInOptions = this.findIndexInList(this.multiSelectOptions, event.option);
        if (event.option) {
            if (event.option.disabled) {
                return;
            }
            if (this.isItemSelected) {
                const clickedItemIndex: number = this.findIndexInList(this.selectedOptions, event.option);
                if (clickedItemIndex != -1) {
                    this.selectedOptions = this.selectedOptions.filter((val, i) => i != clickedItemIndex);
                    this.visibleOptions[index]['isChecked'] = false;
                    this.multiSelectOptions[indexInOptions]['isChecked'] = false;
                } else {
                    this.selectedOptions.push(this.options[indexInOptions]);
                    this.visibleOptions[index]['isChecked'] = true;
                    this.multiSelectOptions[indexInOptions]['isChecked'] = true;
                }
                if (this.selectedOptions && this.selectedOptions.length <= 0) {
                    this.isItemSelected = false;
                }
            } else {
                this.isItemSelected = true;
                this.selectedOptions.push(this.options[indexInOptions]);
                this.visibleOptions[index]['isChecked'] = true;
                this.multiSelectOptions[indexInOptions]['isChecked'] = true;
            }
        }

        const selectedValues = JSON.parse(JSON.stringify(this.selectedOptions));
        this._onChange(selectedValues);
        this.updateLabel();
        this.onChange.emit({
            originalEvent: event.originalEvent,
            selectedOptions: this.selectedOptions,
            clickedOption: this.options[indexInOptions]
        });
    };

    findIndexInList = (optionList, optionItem) => {
        let list = optionList;
        let option = optionItem;
        if (option && this.isArrayOfStrings) {
            if (typeof option == 'string') {
                const stringArray = {};
                stringArray["label"] = optionItem;
                option = stringArray;
            }
            if (this.dropdownService.isArrayOfStringType(list)) {
                list = this.dropdownService.convertStringArrayToArrayOfObjects(list)
            }
        }

        let index: number = -1;
        let selectKey: string;
        if (option && this.optionSelectKey && option[this.optionSelectKey]) {
            selectKey = this.optionSelectKey;
        } else if (option && this.optionLabelKey && option[this.optionLabelKey]) {
            selectKey = this.optionLabelKey;
        } else {
            selectKey = 'label';
        }

        if (list && list.length > 0) {
            if (option && option[selectKey]) {
                for (let i = 0; i < list.length; i++) {
                    if (option[selectKey] == list[i][selectKey]) {
                        index = i;
                        break;
                    }
                }
            }
        }
        return index;
    };

    isOptionSelected = (option) => {
        return this.findIndexInList(this.selectedOptions, option) != -1;
    };

    show = () => {
        if (!this.overlayVisible) {
            this.overlayVisible = true;
        }
        this.visibleOptions = this.multiSelectOptions;
        this.bindDocumentClickListener();
    };

    hide = () => {
        this.overlayVisible = false;
        if (this.isSearchFilter) {
            this.searchInputValue = '';
            this.filterOptions();
        }
        this.unbindDocumentClickListener();
    };

    resetDropdown(event = null) { // set isChecked to false
        event && event.stopPropagation();
        this.selectedOptions = [];
        this.isItemSelected = false;
        this.valueAsString = this.inlineLabel;
        this.isSearchFilter = false;
        this.onReset.emit({});
        this.clearAllCheckBoxesAndFilters();
        this.hide();
        this._onChange([]);
        this.onChange.emit({
            originalEvent: null,
            selectedOptions: [],
            clickedOption: null
        });
    }

    bindDocumentClickListener() {
        if (!this.documentClickListener) {
            this.documentClickListener = this.renderer.listen('document', 'click', () => {
                if (!this.selfClick && this.overlayVisible) {
                    this.hide();
                    this._onTouched();
                }
                this.selfClick = false;
            });
        }
    }

    unbindDocumentClickListener() {
        if (this.documentClickListener) {
            this.documentClickListener();
            this.documentClickListener = null;
        }
    }

    updateSelected = () => {
        if (!this.selectedOptions || this.selectedOptions.length <= 0) return;
        this.isItemSelected = true;
        for (let i = 0; i < this.selectedOptions.length; i++) {
            const indexInOptions = this.findIndexInList(this.multiSelectOptions, this.selectedOptions[i]);
            if (indexInOptions != -1) this.multiSelectOptions[indexInOptions]['isChecked'] = true;
        }
        this.updateLabel();
    };

    getLabel(option) {
        if (this.optionLabelKey && option[this.optionLabelKey]) {
            return option[this.optionLabelKey];
        } else {
            return option.label;
        }
    }

    clearAllCheckBoxesAndFilters() {

        for (let i = 0; i < this.multiSelectOptions.length; i++) {
            this.multiSelectOptions[i]['isChecked'] = false;
        }
        this.visibleOptions = this.multiSelectOptions;

    }

    writeValue(value: any): void {


        if (!this.optionSelectKey) {
            this.selectedOptions = [];
            this.isItemSelected = false;
            this.valueAsString = this.inlineLabel;
            this.isSearchFilter = false;
            this.clearAllCheckBoxesAndFilters();
            this.hide();
        }

        if (value && value.length > 0) {

            for (let i = 0; i < value.length; i++) {
                if (!this.isOptionSelected(value[i]) && this.findIndexInList(this.multiSelectOptions, value[i]) > -1) {
                    this.selectedOptions.push(this.options[this.findIndexInList(this.multiSelectOptions, value[i])]);
                }
            }
        }

        this.updateSelected();
        this.visibleOptions = this.multiSelectOptions;

    }

    registerOnChange(fn: (selectedOptions: any) => void): void {
        this._onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this._onTouched = fn;
    }

    setDisabledState(val: boolean): void {
        this.disable = val;
    }

    onOptionWrapperClick(event, option) {
        this.selfClick = true;
        this.onOptionClick({
            originalEvent: event,
            option: option
        }, option);
    }

    filterOptions() {
        this.selfClick = true;
        const searchLabel: string = this.optionLabelKey && this.optionLabelKey.length > 0 ? this.optionLabelKey : 'label';
        if (this.searchInputValue && this.searchInputValue.length > 0) {
            this.isSearchFilter = true;
            this.visibleOptions = this.dropdownService.filterBySearch(this.multiSelectOptions, searchLabel, this.searchInputValue);
        } else {
            this.isSearchFilter = false;
            this.visibleOptions = this.multiSelectOptions;
        }
    }

    onSearchInputBlur() {
        this.selfClick = false;
    }

    selectByKey(value: any[], key: string) {
        if (this.isArrayOfStrings) {
            this.optionSelectKey = 'label';
            this.writeValue(value);
        } else {
            this.optionSelectKey = key;
            const convertedArrayOfObjects = this.dropdownService.convertStringArrayToArrayOfObjects(value, this.optionSelectKey);
            this.writeValue(convertedArrayOfObjects);
        }
        this.optionSelectKey = null;
        const selectedValues = JSON.parse(JSON.stringify(this.selectedOptions));
        this._onChange(selectedValues);
        this.onChange.emit({
            originalEvent: null,
            selectedOptions: selectedValues,
            clickedOption: null
        });
    }

    UnSelect(options) {
        if (options && options.length > 0) {
            for (let i = 0; i < options.length; i++) {
                const indexInOptions = this.findIndexInList(this.multiSelectOptions, options[i]);
                const selectedItemIndex: number = this.findIndexInList(this.selectedOptions, options[i]);
                if (selectedItemIndex != -1) {
                    this.selectedOptions = this.selectedOptions.filter((val, i) => i != selectedItemIndex);
                    this.multiSelectOptions[indexInOptions]['isChecked'] = false;
                    if (this.visibleOptions) {
                        const index = this.findIndexInList(this.visibleOptions, options[i]);
                        this.visibleOptions[index]['isChecked'] = false;
                    }
                }
            }
        }
        this.updateLabel();
        const selectedValues = JSON.parse(JSON.stringify(this.selectedOptions));
        this._onChange(selectedValues);
        this.onChange.emit({
            originalEvent: null,
            selectedOptions: selectedValues,
            clickedOption: null
        });
    }

    UnSelectByKey(value: any[], key: string): void {
        if (this.isArrayOfStrings) {
            this.optionSelectKey = 'label';
            this.UnSelect(value)
        } else {
            this.optionSelectKey = key;
            const convertedArrayOfObjects = this.dropdownService.convertStringArrayToArrayOfObjects(value, this.optionSelectKey);
            this.UnSelect(convertedArrayOfObjects);
        }
        this.optionSelectKey = null;
    }


}
